export const getCurrentRoute = (path: string) => `/${path.split("/")[1]}`;
